import { defineMessages } from 'react-intl';
import * as DT from '../../constants/constant_custom_tab_types';

export default defineMessages({
  [DT.ON_CHECKOUT]: {
    defaultMessage: 'On-Checkout',
    id: 'custom_tab.on_checkout.title',
  },
  [DT.PROCEED_TO_PAY]: {
    defaultMessage: 'Proceed To Pay',
    id: 'custom_tab.proceed_to_pay.title',
  },
});
